import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

type MyTimelineFilters = {
  itemTypeIn: string[]
}

type MyTimelineFiltersStoreState = {
  myTimelineFilters: MyTimelineFilters
  setMyTimelineFilters: (filters: MyTimelineFilters) => void
}

export const useMyTimelineFiltersStore = create<MyTimelineFiltersStoreState>()(
  persist(
    set => ({
      myTimelineFilters: { itemTypeIn: [] },
      setMyTimelineFilters: filters =>
        set(() => ({
          myTimelineFilters: {
            ...filters,
          },
        })),
    }),
    {
      name: 'myTimelineFilters-storage',
      storage: createJSONStorage(() => localStorage),
    },
  ),
)
